import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 60000;

// Avvisa quando catalogo/listini cambiano sul server mentre la pagina è aperta
export const CatalogUpdateBanner = () => {
  const initial = useRef(null);
  const [outdated, setOutdated] = useState(false);

  useEffect(() => {
    let stopped = false;
    const check = async () => {
      try {
        const { data } = await axios.get(`${API}/catalog/version`);
        if (stopped) return;
        if (initial.current === null) initial.current = data.version;
        else if (data.version !== initial.current) setOutdated(true);
      } catch { /* rete assente o sessione scaduta: riprova al giro successivo */ }
    };
    check();
    const timer = setInterval(check, POLL_MS);
    const onFocus = () => check();
    window.addEventListener('focus', onFocus);
    return () => { stopped = true; clearInterval(timer); window.removeEventListener('focus', onFocus); };
  }, []);

  if (!outdated) return null;
  return (
    <div
      className="sticky top-0 z-40 mb-4 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 shadow-sm"
      role="status"
      data-testid="catalog-update-banner"
    >
      <span className="flex items-center gap-2">
        <RefreshCw className="w-4 h-4" />
        Il catalogo è stato aggiornato. Ricarica la pagina per sincronizzare i dati.
      </span>
      <Button size="sm" onClick={() => window.location.reload()} data-testid="catalog-update-reload">
        Ricarica
      </Button>
    </div>
  );
};
